var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUploadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 35,
    viewBox: "0 0 33 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_2434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7526 9.16577H4.93305C2.76087 9.16577 1 10.9267 1 13.0989V29.9184C1 32.0906 2.76087 33.8514 4.93305 33.8514H21.7526C23.9247 33.8514 25.6857 32.0906 25.6857 29.9184V13.0989C25.6857 10.9267 23.9247 9.16577 21.7526 9.16577Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.33984 32.8802L18.6654 15.6323",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6653 15.6323L25.6858 23.5925",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08778 19.0877C8.74149 19.0877 10.0821 17.7471 10.0821 16.0934C10.0821 14.4397 8.74149 13.0991 7.08778 13.0991C5.43408 13.0991 4.09351 14.4397 4.09351 16.0934C4.09351 17.7471 5.43408 19.0877 7.08778 19.0877Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3567 0H14.1522C12.6885 0 11.502 1.18658 11.502 2.65027V17.8548C11.502 19.3185 12.6885 20.505 14.1522 20.505H29.3567C30.8204 20.505 32.007 19.3185 32.007 17.8548V2.65027C32.007 1.18658 30.8204 0 29.3567 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5364 11.0178V13.5468C28.5364 15.349 27.0856 16.7999 25.2834 16.7999H18.2432C16.4411 16.7999 14.9902 15.349 14.9902 13.5468V11.0178",
    stroke: "#2064A1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7139 2.8855V13.4309",
    stroke: "#2064A1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1235 7.3819L21.7632 2.74219L26.403 7.3819",
    stroke: "#2064A1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_2434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.0069,
    height: 34.8514,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadImage);
export default __webpack_public_path__ + "static/media/icon_upload_image.acb94e7c748d21272e4432591164db69.svg";
export { ForwardRef as ReactComponent };